<template>
  <div class="main-container">
    <page-header>{{'会议议程' | dealLanguage('Meeting agenda')}}</page-header>
    <Spin fix v-if="loading">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <div class="filter-tag">
      <div class="filter-tag-item" v-for="item, index in assort_list" 
      :key="index + 'assort'" 
      :class="{'filter-tag-active' : item == active_assort}"
      @click="changeAssort(item)">{{item}}</div>
    </div>
    <div class="filter-tag">
      <div class="filter-tag-item" v-for="item, index in date_list" 
      :key="index + 'date'" 
      :class="{'filter-tag-active' : item == active_date}"
      @click="changeDate(item)">{{item}}</div>
    </div>
    <div class="flex-wrapper">
      <div class="flex-left">
        <Affix :offset-top="94" v-if="anchor_list.length > 0">
          <Anchor :affix="false" :bounds="300" :offset-top="110" :scroll-offset="80">
            <AnchorLink :href="'#' + index" :title="item.name" v-for="item,index in anchor_list" :key="item.id" />
          </Anchor>
        </Affix>
      </div>
      <div class="flex-right">
        <div class="froum-list">
          <div class="froum-wrapper" v-for="item,index in froum_list" :key="item.activityId" :id="index">
            <div class="froum-base">
              <p>{{item.dateName}}-{{item.activityName}}</p>
              <p><i class="iconfont">&#xe672;</i>{{item.forumPlace}}</p>
            </div>
            <div class="agendas">
              <div class="agenda-item" v-for="(aitem, aindex) in item.agendas">
                <p class="agenda-title">
                  <span class="time">{{aitem.agendaStartTime | time_moment('HH:mm')}}</span>
                  <span class="title">{{aitem.agendaTitle}}</span>
                </p>
                <div class="guest-list">
                  <div class="guest-item" v-for="(gitem, gindex) in aitem.guests">
                    <div class="guest-photo" @click="goGuestDetail(gitem.id)">
                      <img :src="gitem.logoUrl | logo_show" class="photo-img" />
                      <!-- <div class="comp-logo">
                        <img src="https://cdn.vbdata.cn/upload/entity/98e1dc77838bd21fe216a95ffb30e17084.PNG" />
                      </div> -->
                    </div>
                    <div class="guest-info">
                      <div class="guest-name" @click="goGuestDetail(gitem.id)"><span></span>{{gitem.name | dealLanguage(gitem.enName)}}</div>
                      <!-- <div class="guest-title"></div> -->
                      <div class="guest-desc">{{gitem.companyPosition | dealLanguage(gitem.enCompanyPosition)}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <speaker-item v-for="g_item in item.guestDtoList" :key="item.activityId + g_item.id" :itemDetail="g_item"></speaker-item> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/pc/pageHeader.vue'
import { mapState } from 'vuex'
import { getAgendaList } from '@/service/vbef'
import filter from 'js/filter'

export default {
  metaInfo() {
    return {
      title: this.language == 'zh' ? '会议议程' : 'Meeting agenda',
    }
  },
  inject: ['globalInsertRecords'],
  metaInfo() {
    return {
      title: this.language == 'zh' ? '会议议程' : 'Meeting agenda',
    }
  },
  data () {
    return {
      froum_list: [],
      assort_list: [filter.dealLanguage('全部分类', 'All meetings')],
      date_list: [filter.dealLanguage('全部时间', 'All time')],
      first_load: 0,
      active_assort: filter.dealLanguage('全部分类', 'All meetings'),
      active_date: filter.dealLanguage('全部时间', 'All time'),
      anchor_list: [],
      loading: false
    }
  },

  components: {
    PageHeader
  },

  computed: {
    ...mapState({
      user_key: (state) => state.user_key,
      user: (state) => state.user,
      activityId: (state) => state.activityId,
      language: (state) => state.language,
    })
  },

  created() {},

  mounted() {
    this.getAgendaList()
  },

  methods: {
    goGuestDetail(guest_id) {
      this.globalInsertRecords({
        contentId: guest_id,
        contentType: 152,
        viewType: 1
      })
      this.$router.push({
        name: 'guestInfo',
        params: {
          id: guest_id,
        },
      })
    },
    changeAssort(item) {
      this.active_assort = item
      this.getAgendaList()
    },
    changeDate(item) {
      this.active_date = item
      this.getAgendaList()
    },
    async getAgendaList() {
      this.loading = true
      this.anchor_list = []
      let res = await getAgendaList({
        actId: this.activityId,
        assortName: (this.active_assort == '全部分类' || this.active_assort == 'All meetings') ? '' : this.active_assort,
        dateName: (this.active_date == '全部时间' || this.active_date == 'All time') ? '' : this.active_date,
        languageType: this.language == 'zh' ? 0 : 1
      })
      if (res.code == 0) {
        this.$set(this.$data, 'froum_list', res.data.activities)
        this.froum_list.map((a) => {
          let len = this.froum_list.filter(item => item.activityId == a.activityId).length
          let anchor_name = len > 1 ? `${a.activityName}（${a.dateName}）` : a.activityName
          this.anchor_list.push({
            id: a.activityId,
            name: anchor_name,
          })
          if (a.forumPlaceJson) {
            let place = JSON.parse(a.forumPlaceJson)
            let forum = ''
            if (place.level1_show == 1 && place.place_level1) forum += place.place_level1
            if (place.level2_show == 1 && place.place_level2) forum += ' ' + place.place_level2
            if (place.level3_show == 1 && place.place_level3) forum += ' ' + place.place_level3
            this.$set(a, 'forumPlace', forum)
          } else {
            this.$set(a, 'forumPlace', '')
          }
        })
        if (this.first_load == 0) {
          this.assort_list = [...this.assort_list, ...res.data.assortNames]
          this.date_list = [...this.date_list, ...res.data.dateNames]
        }
        this.first_load = 1
      } else {
        this.$Messager.error(filter.dealLanguage(res.msg, res.enMsg || res.msg))
      }
      this.loading = false
    },
  }
}

</script>
<style lang='stylus' scoped>
@import '~styles/common-pc.styl'
@import '~styles/forum-list-pc.styl'
.main-container
  position: relative
.filter-tag
  display flex
  flex-wrap wrap
  margin-top 20px
  &+.filter-tag
    margin-top 0
  &-item
    height 46px
    background #FFFFFF
    border 1px solid #FA5A00
    padding 0 28px
    display flex
    justify-content center
    align-items center
    font-size 16px
    color #FA5A00
    cursor pointer
    transition all 0.5s
    margin-bottom 10px
    &:not(:last-child)
      margin-right 10px
    &:hover
      color #fff
      background #FA5A00
  &-active
    background #FA5A00
    color #fff
.guest-list
  .guest-item
    display flex
    flex 0 0 calc((100% - 40px) / 3)
    margin-bottom: 20px
    &:not(:nth-of-type(3n))
      margin-right: 20px
    .guest-desc
      max-width: 170px
</style>